import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

const RECENT_THREAD_WINDOW_MS = 24 * 60 * 60 * 1000;

const isRelevantSidebarThreadItem = (item = {}) => {
  const updatedAtMs = toThreadTimestampMs(item?.updatedAt);
  const isRecent = Number.isFinite(updatedAtMs) && Date.now() - updatedAtMs <= RECENT_THREAD_WINDOW_MS;

  if (isRecent) {
    return true;
  }

  if (item?.hasPendingInteraction === true) {
    return true;
  }

  if (item?.hasUnopenedAssistantResponse === true) {
    return true;
  }

  return (item?.childThreadItems || []).some((childItem) => isRelevantSidebarThreadItem(childItem));
};

export default isRelevantSidebarThreadItem;
